module.exports = __webpack_public_path__ + "static/img/bg-04.7930487.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/bg-04.png
// module id = AEpT
// module chunks = 65